import { Form, Modal, Row, Col, Button } from "react-bootstrap";
import React, { useState, useContext } from "react";
import { AuthContext } from "../../AuthProvider";
import './HotWaterTimes.css';
import Parse from 'parse';
import { ScreenContext } from "../../ScreenProvider";

const HotWaterTimes = () => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const { esp, setUserEsp } = useContext(AuthContext);
    const { isDarkMode } = useContext(ScreenContext);

    const handleOpenModal = () => {
        setModalIsOpen(true);
    };

    const handleCloseModal = () => {
        setModalIsOpen(false);
    };

    const [timeInput, setTimeInput] = useState("");
    //const [tempInput, setTempInput] = useState("");

    // Function to handle adding a time
    const handleAddTimeAndTemp = () => {
        if (!esp.hotWater) {
            esp.hotWater = {};
        }
        if (!esp.hotWater.hotWaterTimes) {
            esp.hotWater.hotWaterTimes = [];
        }
        if (timeInput && !esp.hotWater.hotWaterTimes.some(item => item.time === timeInput)) {
            const timeAndTemp = { time: timeInput /*, temp: tempInput || 40 */ };

            const hotWaterTimes = [...esp.hotWater.hotWaterTimes, timeAndTemp].sort((a, b) => {
                return new Date(a.time) - new Date(b.time);
            });
            setTimeInput("");
            //setTempInput("");
            Parse.Cloud.run("updateUserEsp", { espId: esp.id, updates: { hotWater: { hotWaterTimes: hotWaterTimes } } }).then((result) => {
                setUserEsp(result);
                Parse.Cloud.run("updateHotWaterHours", { espId: esp.id }).then((hotWaterResult) => {
                    setUserEsp(hotWaterResult);
                });
            });

        }
    };

    // Function to handle input changes
    const handleTimeInputChange = (e) => {
        if (e.keyCode === 13) {
            handleAddTimeAndTemp();
        }
        setTimeInput(e.target.value);
    };

    /*
    const handleTempInputChange = (e) => {
        if (e.keyCode === 13) {
            handleAddTimeAndTemp();
        }
        setTempInput(e.target.value);
    };
    */

    // Function to remove a time from the list
    const handleRemoveTime = (timeToRemove) => {
        const hotWaterTimes = esp.hotWater.hotWaterTimes.filter((item) => item.time !== timeToRemove);
        Parse.Cloud.run("updateUserEsp", { espId: esp.id, updates: { hotWater: { hotWaterTimes: hotWaterTimes } } }).then((result) => {
            //setUserEsp(result);
            Parse.Cloud.run("updateHotWaterHours", { espId: esp.id }).then((hotWaterResult) => {
                setUserEsp(hotWaterResult);
            });
        });
    };

    // Handle Enter key press to submit the time
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent form submission
            handleAddTimeAndTemp(); // Trigger add time when Enter is pressed
        }
    };

    const isDisabled = (input) => {
        return input + (esp?.hotWater?.automationStatus ? "" : " disabled");
    }


    return (
        <>
            <div>
                <button onClick={handleOpenModal} className="controlpanel-button">
                <i className="bi bi-clock controlpanel-button-times-icon" style={{ color: "#85c1e9", position: 'absolute', top: '-10%' }} />
                <span className="controlpanel-button-times-number" style={{ position: 'absolute', top: '-5%' }}>{esp?.hotWater?.hotWaterTimes?.length}&nbsp;st</span>
                <span className="controlpanel-button-times-text" style={{ position: 'absolute', bottom: '-5%' }}>tider</span>
                </button>
            </div>

            <Modal show={modalIsOpen} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Tider för varmvatten</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form className="temp-form">
                        <Row className="align-items-center">
                            <Col xs={3}>
                                <Form.Label>Lägg till</Form.Label>
                            </Col>
                            <Col xs={3}>
                                <Form.Control
                                    type="time"
                                    value={timeInput}
                                    onChange={handleTimeInputChange}
                                    onKeyDown={handleKeyPress}
                                    placeholder="Enter time"
                                    disabled={esp?.hotWater?.automationStatus ? false : true}
                                />
                            </Col>
                            <Col xs={1}>
                                <Button onClick={handleAddTimeAndTemp} className="plus-btn" disabled={esp?.hotWater?.automationStatus ? false : true}>
                                    <i className="bi bi-plus-lg"></i> {/* Bootstrap plus icon */}
                                </Button>
                            </Col>
                        </Row>

                        {/* Display the list of added times */}
                        <div className="times-list">
                            {esp.hotWater?.hotWaterTimes?.length > 0 ? (
                                <ul className="list-group">
                                    {esp.hotWater?.hotWaterTimes.map((item, index) => (
                                        <li key={index} className={isDisabled("list-group-item d-flex justify-content-between align-items-center hot-water-item")}>
                                            <div className="hot-water-time">
                                                <i className="bi bi-clock" style={{ marginRight: '10px' }}></i>{item.time}
                                            </div>
                                            {/* <div className="hot-water-temp">
                                                <i className="bi bi-thermometer-high" style={{ marginRight: '10px' }}></i>{item.temp}°C
                                            </div> */}
                                            <Button className="minus-btn"
                                                variant="danger"
                                                onClick={() => handleRemoveTime(item.time)} // Remove time on click
                                                disabled={esp?.hotWater?.automationStatus ? false : true}
                                            >
                                                <i className="bi bi-dash-lg" style={{ position: 'relative', top: '-5%' }}></i> {/* Minus icon */}
                                            </Button>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <div className={isDarkMode ? "border rounded bg-dark p-2 m-2" : "border rounded bg-light p-2 m-2"}>
                                <p>Inga angivna tider för varmvatten. Vattnet kommer värmas en gång per dygn när elen är som billigast.</p>
                                </div>
                            )}
                            <p className="mt-3 "><small>Vilka tider behövs varmvatten i hushållet som mest? Anges ingen tid värms vattnet en gång per dygn när det är som billigast, vanligtvis under natten. Ju färre tider som anges desto större möjlighet att spara in på elkostnaden.</small></p>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default HotWaterTimes;


